<template>
  <div class="container">
    <!--TABLA DE VUETIFY-->
    <v-data-table
      :headers="fields"
      :items="data"
      class="elevation-3"
      multi-sort
      :search="search"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      hide-default-footer
      @page-count="pageCount = $event"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      show-expand
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="1600px" :key="dialog">
            <v-snackbar
              v-model="showResult"
              :timeout="1500"
              bottom
              :color="snackColor"
            >
              {{ result }}
            </v-snackbar>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
                v-if="
                  getTitle() != 'Histórico de Órdenes' &&
                    getActualRole() != 'ROLE_TALLER' &&
                    getTitle() != 'Órdenes de Trabajo' &&
                    ((getTitle() != 'Tareas' || getTitle() != 'Incidencias') &&
                      getModalCode() != 6)
                "
              >
                Añadir {{ element }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <optional-modals-old
                  :modalCode="modalCode"
                  :info="editedItem"
                  :actualRol="getActualRole()"
                ></optional-modals-old>
              </v-card-text>

              <v-card-actions v-if="getModalCode() != 6">
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
                  v-if="
                    getActualRole() != 'ROLE_TALLER' ||
                      (getActualRole() == 'ROLE_TALLER' &&
                        (getElement() == 'Incidencia' ||
                          getElement() == 'Tarea'))
                  "
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
                  v-if="
                    getActualRole() == 'ROLE_TALLER' &&
                      getElement() != 'Incidencia' &&
                      getElement() != 'Tarea'
                  "
                >
                  Atrás
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="save"
                  v-if="
                    getActualRole() != 'ROLE_TALLER' ||
                      (getActualRole() == 'ROLE_TALLER' &&
                        (getElement() == 'Incidencia' ||
                          getElement() == 'Tarea'))
                  "
                >
                  Continuar
                </v-btn>
              </v-card-actions>
              <v-card-actions v-if="getModalCode() == 6">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close"> Atrás </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="800px">
            <v-card>
              <v-card-title class="text-h5 justify-center"
                >¿Está seguro de querer eliminar este elemento de la
                tabla?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancelar</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >Sí, quiero eliminarlo</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <!--Slots columnas concretas-->
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
          v-if="
            (getActualRole() != 'ROLE_TALLER' ||
              (getActualRole() == 'ROLE_TALLER' &&
                (getElement() == 'Incidencia' || getElement() == 'Tarea'))) &&
              getElement() != 'Historico'
          "
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          @click="deleteItem(item)"
          v-if="
            (getActualRole() != 'ROLE_TALLER' ||
              (getActualRole() == 'ROLE_TALLER' &&
                (getElement() == 'Incidencia' || getElement() == 'Tarea'))) &&
              (getElement() != 'Orden de Trabajo' &&
                getElement() != 'Historico')
          "
        >
          mdi-delete
        </v-icon>
        <v-icon
          small
          @click="editItem(item)"
          v-if="
            (getActualRole() == 'ROLE_TALLER' &&
              (getElement() != 'Incidencia' && getElement() != 'Tarea')) ||
              getElement() == 'Historico'
          "
        >
          mdi-information
        </v-icon>
      </template>
      <template v-slot:[`item.Prioridad.nivel`]="{ item }">
        {{ parsePrioridad(item.Prioridad) }}
      </template>
      <template v-slot:[`item.fecha_entrega`]="{ item }">
        {{ parseFecha(item.fecha_entrega) }}
      </template>
      <template v-slot:[`item.fecha_pedido`]="{ item }">
        {{ parseFecha(item.fecha_pedido) }}
      </template>
      <template v-slot:[`item.roles`]="{ item }">
        {{ getRol(item.roles) }}
      </template>
      <template v-slot:[`item.habilitado`]="{ item }">
        <v-checkbox
          v-model="item.habilitado"
          class="align-center justify-center"
          @click="onCheckboxClicked(item, '/updateHab')"
        ></v-checkbox>
      </template>
      <template v-slot:[`item.resuelta`]="{ item }">
        <v-checkbox
          v-model="item.resuelta"
          class="align-center justify-center"
          @click="onCheckboxClicked(item, '/updateRes')"
        ></v-checkbox>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize"> Refrescar Tablas </v-btn>
      </template>
      <!--Fin de Slots columnas concretas-->
      <template v-slot:bottom>
        <v-toolbar>
          <v-toolbar-title>Expandable Table</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-switch
            v-model="singleExpand"
            label="Single expand"
            class="mt-2"
          ></v-switch>
        </v-toolbar>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <my-detail-row-old
            :item="item"
            :key="item.updatedAt"
          ></my-detail-row-old>
        </td>
      </template>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import apiConfig from "../../../services/api.config";
export default {
  data() {
    return {
      showResult: false,
      result: "",
      snackColor: "",
      //VUETIFY TABLE
      dialog: false,
      dialogDelete: false,
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      search: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 50,
      //maxLevel: 1,

      expanded: [],
      singleExpand: false,
      data: [],
      actualRol: "",
    };
  },
  props: {
    fields: Array,
    title: String,
    element: String,
    modalCode: Number,
    url: String,
    pedidoId: Number,
    refactor: Boolean
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Crear " + this.element
        : "Editar " + this.element;
    }
  },
  created() {
    this.initialize();
    this.actualRol = this.$store.state.auth.user.roles[
      this.$store.state.auth.user.roles.length - 1
    ];
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    // eslint-disable-next-line
    refactor(val) {
      this.init();
      this.$emit("recharge");
    }
  },
  methods: {
    getTitle() {
      return this.title;
    },
    getModalCode() {
      return this.modalCode;
    },
    getElement() {
      return this.element;
    },
    getActualRole() {
      return this.actualRol;
    },
    initialize() {
      this.init();
    },
    capitalizeFirst(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    getRol(roles) {
      return this.capitalizeFirst(roles[roles.length - 1]);
    },
    onCheckboxClicked(item, action) {
      if (action == "/updateRes") {
        axios
          .put(
            this.$baseBackUrl + "api/incidencias/" + item.id + action,
            item,
            apiConfig.connData()
          )
          // eslint-disable-next-line
          .then(response => {
            this.initialize();
          })
          .catch(e => {
            console.log(e);
          });
      } else {
        axios
          .put(this.url + "/" + item.id + action, item, apiConfig.connData())
          // eslint-disable-next-line
          .then(response => {
            this.initialize();
          })
          .catch(e => {
            console.log(e);
          });
      }
    },
    parseFecha(fecha) {
      var m = new Date(fecha);
      var nf =
        ("0" + m.getUTCDate()).slice(-2) +
        "/" +
        ("0" + (m.getUTCMonth() + 1)).slice(-2) +
        "/" +
        m.getUTCFullYear();
      return nf;
    },
    parseFecha2(fecha) {
      var m = new Date(fecha);
      var nf =
        m.getUTCFullYear() +
        "-" +
        ("0" + (m.getUTCMonth() + 1)).slice(-2) +
        "-" +
        ("0" + m.getUTCDate()).slice(-2);
      return nf;
    },
    parsePrioridad(prio) {
      var nf = prio.nombre;
      return nf;
    },
    parseTipoInc(ti) {
      var nf = ti;
      return nf;
    },
    async init() {
      if (this.title == "Gestión de Usuarios") {
        var uri = this.url + "/user/" + this.$store.state.auth.user.id;
        await axios
          .get(uri, apiConfig.connData())
          .then(response => {
            this.data = response.data;
          })
          .catch(e => {
            console.log(e);
          });
      } else {
        await axios
          .get(this.url, apiConfig.connData())
          .then(response => {
            if (this.refactor) {
              var d = [];
              response.data.forEach(ot => {
                if (ot.id_user != null) {
                  d.push(ot);
                }
              });
              this.data = d;
            } else {
              this.data = response.data;
            }
          })
          .catch(e => {
            console.log(e);
          });
      }
    },

    editItem(item) {
      this.editedIndex = this.data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      if (this.modalCode <= 2 || this.modalCode == 5) {
        if (this.url.includes("historicas")) {
          axios
            .delete(
              this.$baseBackUrl + "api/pedidos/" + this.editedItem.id,
              apiConfig.connData()
            )
            // eslint-disable-next-line
            .then(response => {
              //this.initialize();
            })
            .catch(e => {
              console.log(e);
            });
        } else {
          axios
            .delete(this.url + "/" + this.editedItem.id, apiConfig.connData())
            // eslint-disable-next-line
            .then(response => {
              //this.initialize();
            })
            .catch(e => {
              console.log(e);
            });
        }
      } else {
        if (this.modalCode == 3) {
          axios
            .delete(
              this.$baseBackUrl + "api/tareas/" + this.editedItem.id,
              apiConfig.connData()
            )
            // eslint-disable-next-line
            .then(response => {
              this.result = "Éxito al modificar la Base de Datos";
              this.snackColor = "success";
              this.showResult = true;
              //this.initialize();
            })
            // eslint-disable-next-line
            .catch(e => {
              this.result = "Error al modificar la Base de Datos";
              this.snackColor = "error";
              this.showResult = true;
            });
        } else if (this.modalCode == 4) {
          axios
            .delete(
              this.$baseBackUrl + "api/incidencias/" + this.editedItem.id,
              apiConfig.connData()
            )
            // eslint-disable-next-line
            .then(response => {
              this.result = "Éxito al modificar la Base de Datos";
              this.snackColor = "success";
              this.showResult = true;
              //this.initialize();
            })
            // eslint-disable-next-line
            .catch(e => {
              this.result = "Error al modificar la Base de Datos";
              this.snackColor = "error";
              this.showResult = true;
            });
        }
      }
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.init();
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      if (this.modalCode == 5) {
        //this.getMaxLevel();
      }
      this.$parent.$emit("warn");
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.init();
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      if (this.modalCode == 5) {
        //this.getMaxLevel();
      }
      this.$parent.$emit("warn");
    },
    async editElement() {
      if (this.modalCode == 1) {
        var uri = this.url + "/" + this.editedItem.id;
        var userObj = {};
        switch (this.editedItem.habilitado) {
          case true:
            this.editedItem.habilitado = 1;
            break;
          case false:
            this.editedItem.habilitado = 0;
            break;
        }
        if (
          /^\s*$/.test(this.editedItem.username) ||
          this.editedItem.username == undefined
        ) {
          this.result = "Usuario no definido";
          this.snackColor = "error";
          this.showResult = true;
        } else if (
          /^\s*$/.test(this.editedItem.nombre) ||
          this.editedItem.nombre == undefined
        ) {
          this.result = "Nombre no definido";
          this.snackColor = "error";
          this.showResult = true;
        } else if (
          /^\s*$/.test(this.editedItem.email) ||
          this.editedItem.email == undefined
        ) {
          this.result = "Email no definido";
          this.snackColor = "error";
          this.showResult = true;
        } else if (this.editedItem.roles == null) {
          this.result = "Asigne un rol";
          this.snackColor = "error";
          this.showResult = true;
        } else {
          if (this.editedItem.createdAt != undefined) {
            userObj.createdAt = this.editedItem.createdAt;
          }
          if (this.editedItem.username != undefined) {
            userObj.username = this.editedItem.username;
          }
          if (this.editedItem.email != undefined) {
            userObj.email = this.editedItem.email;
          }
          if (this.editedItem.nombre != undefined) {
            userObj.nombre = this.editedItem.nombre;
          }
          if (this.editedItem.habilitado != undefined) {
            userObj.habilitado = this.editedItem.habilitado;
          }
          if (this.editedItem.password != undefined) {
            userObj.password = this.editedItem.password;
          }
          if (this.editedItem.roles != undefined) {
            userObj.roles = this.editedItem.roles;
            userObj.roles.forEach((rol, index) => {
              if (rol == "taller") {
                userObj.roles[index] = 1;
              } else if (rol == "oficina") {
                userObj.roles[index] = 2;
              } else if (rol == "admin") {
                userObj.roles[index] = 3;
              }
            });
          }
          axios
            .put(uri, userObj, apiConfig.connData())
            // eslint-disable-next-line
            .then(response => {
              this.result = "Éxito al modificar la Base de Datos";
              this.snackColor = "success";
              this.showResult = true;
              setTimeout(() => {
                this.close();
              }, 500);
            })
            // eslint-disable-next-line
            .catch(e => {
              this.result = "Error al modificar la Base de Datos";
              this.snackColor = "error";
              this.showResult = true;
            });
        }
      } else if (this.modalCode == 0) {
        if (/^\s*$/.test(this.editedItem.codigo)) {
          this.result = "Código vacío";
          this.snackColor = "error";
          this.showResult = true;
        } else if (/^\s*$/.test(this.editedItem.nombre)) {
          this.result = "Nombre vacío";
          this.snackColor = "error";
          this.showResult = true;
        } else {
          axios
            .put(
              this.url + "/" + this.editedItem.id,
              this.editedItem,
              apiConfig.connData()
            )
            // eslint-disable-next-line
            .then(response => {
              this.result = "Éxito al modificar la Base de Datos";
              this.snackColor = "success";
              this.showResult = true;
              setTimeout(() => {
                this.close();
              }, 500);
            })
            // eslint-disable-next-line
            .catch(e => {
              this.result = "Error al modificar la Base de Datos";
              this.snackColor = "error";
              this.showResult = true;
            });
        }
      } else if (this.modalCode == 5) {
        //this.getMaxLevel();
        this.maxLevel = this.maxLevel - 1;
        if (/^\s*$/.test(this.editedItem.codigo)) {
          this.result = "Código vacío";
          this.snackColor = "error";
          this.showResult = true;
        } else if (/^\s*$/.test(this.editedItem.nombre)) {
          this.result = "Nombre vacío";
          this.snackColor = "error";
          this.showResult = true;
        } else if (/^\s*$/.test(this.editedItem.nivel)) {
          this.result = "Nivel vacío";
          this.snackColor = "error";
          this.showResult = true;
        } else if (
          this.editedItem.nivel > this.maxLevel ||
          this.editedItem.nivel < 1
        ) {
          if (this.maxLevel > 1) {
            this.result =
              "El nivel de prioridad establecido deberá estar entre los valores 1 y " +
              this.maxLevel;
            this.snackColor = "error";
            this.showResult = true;
          } else {
            this.result = "El nivel de prioridad establecido deberá ser 1";
            this.snackColor = "error";
            this.showResult = true;
          }
        } else {
          await axios
            .put(
              this.url + "/" + this.editedItem.id,
              this.editedItem,
              apiConfig.connData()
            )
            // eslint-disable-next-line
            .then(response => {
              this.result = "Éxito al modificar la Base de Datos";
              this.snackColor = "success";
              this.showResult = true;
              setTimeout(() => {
                this.close();
              }, 500);
            })
            // eslint-disable-next-line
            .catch(e => {
              this.result = "Error al modificar la Base de Datos";
              this.snackColor = "error";
              this.showResult = true;
              console.log(e);
            });
        }
      } else if (this.modalCode == 2) {
        if (this.editedItem.estado == null) {
          this.result = "Asigne un estado";
          this.snackColor = "error";
          this.showResult = true;
        } else if (this.editedItem.Prioridad == null) {
          this.result = "Asigne una prioridad";
          this.snackColor = "error";
          this.showResult = true;
        } else if (
          /^\s*$/.test(this.editedItem.cliente) ||
          this.editedItem.cliente == undefined
        ) {
          this.result = "Cliente sin determinar";
          this.snackColor = "error";
          this.showResult = true;
        } else if (this.editedItem.fecha_pedido == null) {
          this.result = "Agregue una fecha de pedido";
          this.snackColor = "error";
          this.showResult = true;
        } else if (this.editedItem.fecha_entrega == null) {
          this.result = "Agregue una fecha de entrega";
          this.snackColor = "error";
          this.showResult = true;
        } else if (
          this.editedItem.fecha_pedido > this.editedItem.fecha_entrega
        ) {
          this.result =
            "La fecha de pedido no puede ser posterior a la de entrega";
          this.snackColor = "error";
          this.showResult = true;
        } else {
          var json = {
            id: this.editedItem.id,
            id_erp: this.editedItem.id_erp,
            id_prioridad: this.editedItem.id_prioridad,
            id_cliente: this.editedItem.id_cliente,
            plano_asociado: this.editedItem.plano_asociado,
            notas: this.editedItem.notas,
            material_detalle: this.editedItem.material_detalle,
            id_familia_material: this.editedItem.id_familia_material,
            id_estado: this.editedItem.id_estado,
            id_user: this.editedItem.id_user,
            fecha_pedido: this.editedItem.fecha_pedido,
            fecha_entrega: this.editedItem.fecha_entrega
          };
          if (this.url.includes("historicas") || this.url.includes("pedidos")) {
            axios
              .put(
                this.$baseBackUrl + "api/pedidos/" + this.editedItem.id,
                // this.editedItem,
                json,
                apiConfig.connData()
              )
              // eslint-disable-next-line
              .then(response => {
                this.result = "Éxito al modificar la Base de Datos";
                this.snackColor = "success";
                this.showResult = true;
                setTimeout(() => {
                  this.close();
                }, 500);
              })
              // eslint-disable-next-line
              .catch(e => {
                this.result = "Error al modificar la Base de Datos";
                this.snackColor = "error";
                this.showResult = true;
              });
          } else {
            axios
              .put(
                this.url + "/" + this.editedItem.id,
                // this.editedItem,
                json,
                apiConfig.connData()
              )
              // eslint-disable-next-line
              .then(response => {
                this.result = "Éxito al modificar la Base de Datos";
                this.snackColor = "success";
                this.showResult = true;
                setTimeout(() => {
                  this.close();
                }, 500);
              })
              // eslint-disable-next-line
              .catch(e => {
                this.result = "Error al modificar la Base de Datos";
                this.snackColor = "error";
                this.showResult = true;
              });
          }
        }
      } else if (this.modalCode == 3) {
        if (
          /^\s*$/.test(this.editedItem.descripcion) ||
          this.editedItem.descripcion == undefined
        ) {
          this.result = "Descripción vacía";
          this.snackColor = "error";
          this.showResult = true;
        } else if (
          /^\s*$/.test(this.editedItem.cantidad) ||
          this.editedItem.cantidad == undefined
        ) {
          this.result = "Cantidad vacía";
          this.snackColor = "error";
          this.showResult = true;
        } else if (this.editedItem.cantidad < 1) {
          this.result = "Valor mínimo -> 1";
          this.snackColor = "error";
          this.showResult = true;
        } else {
          axios
            .put(
              this.$baseBackUrl + "api/tareas/" + this.editedItem.id,
              this.editedItem,
              apiConfig.connData()
            )
            // eslint-disable-next-line
            .then(response => {
              this.result = "Éxito al modificar la Base de Datos";
              this.snackColor = "success";
              this.showResult = true;
              setTimeout(() => {
                this.close();
              }, 500);
            })
            // eslint-disable-next-line
            .catch(e => {
              this.result = "Error al modificar la Base de Datos";
              this.snackColor = "error";
              this.showResult = true;
            });
        }
      } else if (this.modalCode == 4) {
        if (/^\s*$/.test(this.editedItem.descripcion)) {
          this.result = "Descripción vacía";
          this.snackColor = "error";
          this.showResult = true;
        } else {
          axios
            .put(
              this.$baseBackUrl + "api/incidencias/" + this.editedItem.id,
              this.editedItem,
              apiConfig.connData()
            )
            // eslint-disable-next-line
            .then(response => {
              this.result = "Éxito al modificar la Base de Datos";
              this.snackColor = "success";
              this.showResult = true;
              setTimeout(() => {
                this.close();
              }, 500);
            })
            // eslint-disable-next-line
            .catch(e => {
              this.result = "Error al modificar la Base de Datos";
              this.snackColor = "error";
              this.showResult = true;
            });
        }
      }
      //this.initialize();
    },
    addElement() {
      if (this.modalCode != 1) {
        this.axiosAddItem();
      } else {
        switch (this.editedItem.habilitado) {
          case true:
            this.editedItem.habilitado = 1;
            break;
          case false:
            this.editedItem.habilitado = 0;
            break;
        }
        if (
          /^\s*$/.test(this.editedItem.username) ||
          this.editedItem.username == undefined
        ) {
          this.result = "Usuario no definido";
          this.snackColor = "error";
          this.showResult = true;
        } else if (
          /^\s*$/.test(this.editedItem.nombre) ||
          this.editedItem.nombre == undefined
        ) {
          this.result = "Nombre no definido";
          this.snackColor = "error";
          this.showResult = true;
        } else if (
          /^\s*$/.test(this.editedItem.email) ||
          this.editedItem.email == undefined
        ) {
          this.result = "Email no definido";
          this.snackColor = "error";
          this.showResult = true;
        } else if (this.editedItem.roles == null) {
          this.result = "Asigne un rol";
          this.snackColor = "error";
          this.showResult = true;
        } else if (
          /^\s*$/.test(this.editedItem.password) ||
          this.editedItem.password == undefined
        ) {
          this.result = "Contraseña no definida";
          this.snackColor = "error";
          this.showResult = true;
        } else {
          this.editedItem.roles.forEach((rol, index) => {
            if (rol == 1) {
              this.editedItem.roles[index] = "taller";
            } else if (rol == 2) {
              this.editedItem.roles[index] = "oficina";
            } else if (rol == 3) {
              this.editedItem.roles[index] = "admin";
            }
          });
          this.authSignInUser();
        }
      }
    },
    axiosAddItem() {
      if (this.modalCode == 2) {
        if (this.editedItem.estado == null) {
          this.result = "Asigne un estado";
          this.snackColor = "error";
          this.showResult = true;
        } else if (this.editedItem.prioridad == null) {
          this.result = "Asigne una prioridad";
          this.snackColor = "error";
          this.showResult = true;
        } else if (
          /^\s*$/.test(this.editedItem.cliente) ||
          this.editedItem.cliente == undefined
        ) {
          this.result = "Cliente sin determinar";
          this.snackColor = "error";
          this.showResult = true;
        } else if (this.editedItem.fecha_pedido == null) {
          this.result = "Agregue una fecha de inicio";
          this.snackColor = "error";
          this.showResult = true;
        } else if (this.editedItem.fecha_entrega == null) {
          this.result = "Agregue una fecha de entrega";
          this.snackColor = "error";
          this.showResult = true;
        } else if (
          this.editedItem.fecha_pedido > this.editedItem.fecha_entrega
        ) {
          this.result =
            "La fecha de inicio no puede ser posterior a la de entrega";
          this.snackColor = "error";
          this.showResult = true;
        } else {
          if (this.url.includes("historicas")) {
            axios
              .post(
                this.$baseBackUrl + "api/pedidos",
                this.editedItem,
                apiConfig.connData()
              )
              .then(response => {
                this.data.push(response.data);
                this.result = "Éxito al modificar la Base de Datos";
                this.snackColor = "success";
                this.showResult = true;
              })
              // eslint-disable-next-line
              .catch(e => {
                this.result = "Error al modificar la Base de Datos";
                this.snackColor = "error";
                this.showResult = true;
              });
          } else {
            axios
              .post(this.url, this.editedItem, apiConfig.connData())
              .then(response => {
                this.data.push(response.data);
              })
              // eslint-disable-next-line
              .catch(e => {
                this.result = "Error al modificar la Base de Datos";
                this.snackColor = "error";
                this.showResult = true;
              });
          }

          this.close();
        }
      } else if (this.modalCode == 0) {
        if (
          /^\s*$/.test(this.editedItem.codigo) ||
          this.editedItem.codigo == undefined
        ) {
          this.result = "Código vacío";
          this.snackColor = "error";
          this.showResult = true;
        } else if (
          /^\s*$/.test(this.editedItem.nombre) ||
          this.editedItem.nombre == undefined
        ) {
          this.result = "Nombre vacío";
          this.snackColor = "error";
          this.showResult = true;
        } else {
          axios
            .post(this.url, this.editedItem, apiConfig.connData())
            .then(response => {
              this.data.push(response.data);
              this.result = "Éxito al modificar la Base de Datos";
              this.snackColor = "success";
              this.showResult = true;
              setTimeout(() => {
                this.close();
              }, 500);
            })
            // eslint-disable-next-line
            .catch(e => {
              this.result = "Error al modificar la Base de Datos";
              this.snackColor = "error";
              this.showResult = true;
            });
        }
      } else if (this.modalCode == 5) {
        //this.getMaxLevel();
        if (
          /^\s*$/.test(this.editedItem.codigo) ||
          this.editedItem.codigo == undefined
        ) {
          this.result = "Código vacío";
          this.snackColor = "error";
          this.showResult = true;
        } else if (
          /^\s*$/.test(this.editedItem.nombre) ||
          this.editedItem.nombre == undefined
        ) {
          this.result = "Nombre vacío";
          this.snackColor = "error";
          this.showResult = true;
        } else if (
          /^\s*$/.test(this.editedItem.nivel) ||
          this.editedItem.nivel == undefined
        ) {
          this.result = "Nivel vacío";
          this.snackColor = "error";
          this.showResult = true;
        } else {
          axios
            .post(this.url, this.editedItem, apiConfig.connData())
            .then(response => {
              this.data.push(response.data);
              this.result = "Éxito al modificar la Base de Datos";
              this.snackColor = "success";
              this.showResult = true;
              setTimeout(() => {
                this.close();
              }, 500);
            })
            // eslint-disable-next-line
            .catch(e => {
              this.result = "Error al modificar la Base de Datos";
              this.snackColor = "error";
              this.showResult = true;
            });
        }
      } else if (this.modalCode == 3) {
        this.editedItem.id_pedido = this.pedidoId;
        if (
          /^\s*$/.test(this.editedItem.descripcion) ||
          this.editedItem.descripcion == undefined
        ) {
          this.result = "Descripción vacía";
          this.snackColor = "error";
          this.showResult = true;
        } else if (
          /^\s*$/.test(this.editedItem.cantidad) ||
          this.editedItem.cantidad == undefined
        ) {
          this.result = "Cantidad vacía";
          this.snackColor = "error";
          this.showResult = true;
        } else if (this.editedItem.cantidad < 1) {
          this.result = "Valor mínimo -> 1";
          this.snackColor = "error";
          this.showResult = true;
        } else {
          axios
            .post(
              this.$baseBackUrl + "api/tareas/",
              this.editedItem,
              apiConfig.connData()
            )
            // eslint-disable-next-line
            .then(response => {
              this.result = "Éxito al modificar la Base de Datos";
              this.snackColor = "success";
              this.showResult = true;
              setTimeout(() => {
                this.close();
              }, 500);
              //this.initialize();
            })
            // eslint-disable-next-line
            .catch(e => {
              this.result = "Error al modificar la Base de Datos";
              this.snackColor = "error";
              this.showResult = true;
            });
        }
      } else if (this.modalCode == 4) {
        this.editedItem.id_pedido = this.pedidoId;
        if (
          /^\s*$/.test(this.editedItem.descripcion) ||
          this.editedItem.descripcion == undefined
        ) {
          this.result = "Descripción vacía";
          this.snackColor = "error";
          this.showResult = true;
        } else if (this.editedItem.tipo_incidencia == null) {
          this.result = "Asigne un tipo de incidencia";
          this.snackColor = "error";
          this.showResult = true;
        } else {
          axios
            .post(
              this.$baseBackUrl + "api/incidencias/",
              this.editedItem,
              apiConfig.connData()
            )
            // eslint-disable-next-line
            .then(response => {
              this.close();
              //this.initialize();
            })
            // eslint-disable-next-line
            .catch(e => {
              console.log(e);
            });
        }
      }
    },
    authSignInUser() {
      axios
        .post(
          this.$baseBackUrl + "api/auth/signup",
          this.editedItem,
          apiConfig.connData()
        )
        // eslint-disable-next-line
        .then(response => {
          this.initialize();
          this.result = "Éxito al modificar la Base de Datos";
          this.snackColor = "success";
          this.showResult = true;
          setTimeout(() => {
            this.close();
          }, 500);
        })
        // eslint-disable-next-line
        .catch(e => {
          this.result = "Error al modificar la Base de Datos";
          this.snackColor = "error";
          this.showResult = true;
        });
    },
    save() {
      if (this.editedIndex > -1) {
        this.editElement();
      } else {
        this.addElement();
      }
      //this.close();
    }
  }
};
</script>
<style>
.container {
  width: 95%;
}
.v-input__slot {
  align-items: center;
  justify-content: center;
}
.btn-primary {
  background-color: #004283;
  margin-left: 1em;
  margin-bottom: 1em;
  padding-left: 1em;
}
.bg-blu {
  background-color: #004283;
  color: #fff;
}
.bg-white {
  background-color: #fff;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
button.ui.button {
  padding: 8px 3px 8px 10px;
  margin-top: 1px;
  margin-bottom: 1px;
}
.vuetable-th-gutter {
  width: 0;
}
.dx-viewport {
  display: flex;
}
#ui {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
h1 {
  color: #004283;
}
</style>



// WEBPACK FOOTER //
// src/components/table/old/MyTableOld.vue